import styled from "@emotion/styled";
import { Col, Empty, FormInstance, Input, Radio, Row } from "antd";
import { useState, FC, Dispatch, SetStateAction, useEffect } from "react";
 import type { RadioChangeEvent } from 'antd';
import { Pagination } from 'antd';
import { AddressData } from "components/ManageAgent/CreateAgent/AddressComponents/interface/address.interface";
import { TaxAddressData } from "services/interface";
import TaxAddressCard from "../TaxAddressCard";

const { Search } = Input;


// const suffix = (
//   <AudioOutlined
//     style={{
//       fontSize: 16,
//       color: '#1677ff',
//     }}
//   />
// );

// const onSearch: SearchProps['onSearch'] = (value, _e, info) => console.log(info?.source, value);
interface TaxAddressCardListProp {
  // form: FormInstance;
  dataAddressTax: TaxAddressData[];
  setDataAddressTax: Dispatch<SetStateAction<TaxAddressData[]>>;
  handleRemoveItem?: (index: any) => void;
  showEdit?: (id: string)=> void;
  setRadio?: (id: string)=> void;
  radio: string;
  changeDefault?: (id: string)=> void;
}


const TaxAddressCardList: FC<TaxAddressCardListProp> = ({
  // form,
  dataAddressTax, setDataAddressTax, handleRemoveItem, showEdit, setRadio, radio, changeDefault}) => {
  const [value, setValue] = useState<string>(radio);

  useEffect(() => {
    setValue(radio);
  }, [radio]);

  const onChange = (e: RadioChangeEvent) => {
    const { value } = e.target;
    setValue(value);
    if (setRadio) {
      setRadio(value);
    }
  };

  // const sortedData = [...dataAddress].sort((a, b) => {
  //   if (a.is_default && !b.is_default) {
  //     return -1;
  //   } else if (!a.is_default && b.is_default) {
  //     return 1;
  //   }
  //   if (a.province_name && b.province_name) {
  //     if (a.province_name < b.province_name) {
  //       return -1;
  //     } else if (a.province_name > b.province_name) {
  //       return 1;
  //     }
  //   }
  //   return 0;
  // });
  
  // const [showContent, setShowContent] = useState(true);
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;  
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = currentPage * itemsPerPage;

  return (
    <>
     <WrapperAll>
      <HeadWrapper>
      {/* {sortedData && sortedData.length > 0 && (
        <></>
        <PaginationWrapper
          current={currentPage}
          size={'small'}
          responsive={true}
          // totalBoundaryShowSizeChanger={3}
          onChange={(page) => setCurrentPage(page)}
          // total={data?.contacts?.length || 0}
          total={1000}
          // defaultCurrent={3} 
          // showTotal={showTotal}
          showSizeChanger
          // showQuickJumper
          pageSize={itemsPerPage}
          // showSizeChanger={false}
        />
      )} */}
      </HeadWrapper>
      <StyledRadioGroup name="radiogroup" onChange={onChange} value={value}>
        <Row style={{ overflow: "auto", padding: '5px'}}>
          
        {dataAddressTax && dataAddressTax.length > 0 ?
            dataAddressTax && dataAddressTax.map((item, index) => {
              return (  
                  <TaxAddressCard
                    key={index}
                    index={index}
                    data={item}
                    handleRemoveItem={handleRemoveItem}
                    showEdit={showEdit}
                    canUpdate={true}
                    changeDefault={changeDefault}
                  />
              );
            })
          :
          <Col span={24} >
            <NotFoundWrapper>
              <Empty description={"ไม่มีที่อยู่ กรุณาเพิ่มที่อยู่ใหม่"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </NotFoundWrapper>
          </Col>
        }
        </Row>
      </StyledRadioGroup>
    </WrapperAll>
    </>
  );
};

export default TaxAddressCardList;

const StyledRadioGroup = styled(Radio.Group)`
  border: none;
  margin: 0;
  display: block;
`;

const PaginationWrapper = styled(Pagination)`
  white-space: nowrap;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
`;

const NotFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  flex-direction: column;
  width: 100%;
`;